import React, { useEffect, useMemo, useRef, useState } from "react";
import "./style.css";
import { ImagePath } from "../helper/ImagePath";

import decrypted from "../helper/decrpted";
// import { logEvent } from "firebase/analytics";
import { analytics } from "./FireBaseConsole";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { MessageCircle, Link2, X, Check } from "lucide-react";
import { getRefferlLInkCount } from "../store/actions";
import { WhatsappIcon } from "react-share";

const Marketing = () => {
    const [materials, setMaterials] = useState([]);
    const [shareItem, setShareItem] = useState(null); // item currently open in the share popup
    const [copied, setCopied] = useState(false);
    const dispatch = useDispatch();
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const decryptedResult = decrypted(userData);
    const uniqueCode = decryptedResult?.username;

    useEffect(() => {
        const link = "client";
        fetchMaterials();
        dispatch(
            getRefferlLInkCount({
                code: uniqueCode,
                link_type: link,
            })
        );
    }, []);

    const { refferalData } = useSelector((state) => ({
        refferalData: state?.refferalData?.refferalData,
    }));

    const fetchMaterials = async () => {
        try {
            const res = await axios.get(
                "https://bcms.bigul.co/api/list-media-material"
            );

            console.log(res.data);
            setMaterials(res.data); // response direct array hai
        } catch (err) {
            console.log(err);
        }
    };

    // Opens the custom share popup for the selected item instead of the
    // native navigator.share sheet.
    const shareMaterial = (item) => {
        setShareItem(item);
        setCopied(false);
    };

    // The link that gets copied / shared. Falls back to a demo link if
    // the referral link hasn't loaded yet.
    const getShareUrl = () =>
        refferalData?.link || "https://bigul.co/marketing/creative/12345";

    const getShareMessage = () => shareItem?.message || "";

    const getShareImage = () => shareItem?.link || "";

    // Copies the referral link to the clipboard and shows a temporary
    // "Copied" confirmation.
    const handleCopyLink = async () => {
        const url = getShareUrl();
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.log("Copy failed", err);
        }
    };

    // Opens the correct share dialog for a given platform, passing the
    // link + message (and image where the platform's share intent
    // supports it).
    const handleSocialShare = (platform) => {
        const url = getShareUrl();
        const message = getShareMessage();
        const image = getShareImage();
        const text = `${message} ${url}`.trim();

        switch (platform) {
            case "facebook":
                window.open(
                    `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        url
                    )}&quote=${encodeURIComponent(message)}`,
                    "_blank",
                    "noopener,noreferrer"
                );
                break;

            case "email":
                window.location.href = `mailto:?subject=${encodeURIComponent(
                    "Check this out"
                )}&body=${encodeURIComponent(text)}`;
                break;

            case "twitter":
                window.open(
                    `https://twitter.com/intent/tweet?text=${encodeURIComponent(
                        message
                    )}&url=${encodeURIComponent(url)}`,
                    "_blank",
                    "noopener,noreferrer"
                );
                break;

            case "instagram":
                // Instagram has no web share intent for links, so we copy the
                // message + link and open Instagram; on mobile with the app
                // installed the user can paste it directly into a DM/story.
                navigator.clipboard?.writeText(text).catch(() => { });
                window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");
                break;

            case "youtube":
                // YouTube also has no share-intent URL, so we copy the text
                // and open YouTube as a best-effort fallback.
                navigator.clipboard?.writeText(text).catch(() => { });
                window.open("https://www.youtube.com/", "_blank", "noopener,noreferrer");
                break;

            case "telegram":
                window.open(
                    `https://t.me/share/url?url=${encodeURIComponent(
                        url
                    )}&text=${encodeURIComponent(message)}`,
                    "_blank",
                    "noopener,noreferrer"
                );
                break;

            case "whatsapp":
                window.open(
                    `https://wa.me/?text=${encodeURIComponent(text)}`,
                    "_blank",
                    "noopener,noreferrer"
                );
                break;

            default:
                break;
        }

        // On mobile browsers that support the native share sheet, use it
        // instead so the image itself can also be shared where possible.
        if (navigator.share && navigator.canShare) {
            navigator.share({
                title: message,
                text: message,
                url,
            }).catch(() => { });
        }
    };

    const socialPlatforms = [
        { key: "facebook", icon: ImagePath.social1 },
        { key: "email", icon: ImagePath.social2 },
        { key: "twitter", icon: ImagePath.social3 },
        { key: "instagram", icon: ImagePath.social4 },
        { key: "youtube", icon: ImagePath.social5 },
        { key: "telegram", icon: ImagePath.social6 },
        { key: "whatsapp", icon: ImagePath.social7 },
    ];

    return (
        <div className="container">
            <div className="market-material-wrapper">
                <div className="heading">
                    <h3>Marketing Material</h3>
                    <p>
                        Access ready-to-share marketing materials and campaign assets.
                    </p>
                </div>

                <div className="card-box">
                    {materials.map((item) => (
                        <div className="item" key={item.id}>
                            <div className="item-content">
                                <div className="image">
                                    <img src={item.link} alt={item.message} />
                                </div>

                                <h4>
                                    {item.message.length > 55
                                        ? item.message.substring(0, 55) + "..."
                                        : item.message}
                                </h4>

                                <p>{item.message}</p>
                            </div>
                            <button
                                className="share-btn"
                                onClick={() => shareMaterial(item)}
                            >
                                <img src={ImagePath.sharemarketing} alt="share" />
                                Share
                            </button>
                        </div>
                    ))}
                </div>

                {shareItem && (
                    <div
                        className="share-popup-overlay"
                        onClick={() => setShareItem(null)}
                    >
                        <div className="share-popup" onClick={(e) => e.stopPropagation()}>
                            <div className="icon">
                                <img src={ImagePath.share_icon} alt="" />
                            </div>
                            <h3>Share Marketing Material</h3>
                            <p>
                                Share this marketing creative with your clients, prospects, or
                                network.
                            </p>
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={getShareUrl()}
                                    readOnly
                                />
                                <button className="btun" onClick={handleCopyLink}>
                                    {copied ? "Copied" : "Copy Link"}
                                </button>
                            </div>
                            <p>Or share via</p>
                            <ul>
                                {socialPlatforms.map(({ key, icon }) => (
                                    <li key={key}>
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleSocialShare(key);
                                            }}
                                        >
                                            <img src={icon} alt={key} />
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Marketing;